



























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class OverviewStatisticCard extends Vue {
  @Prop({ required: true, type: String })
  label!: string;

  @Prop({ required: true, type: String })
  value!: string;

  @Prop({ required: false, type: String, default: '' })
  subtitle!: string;

  /** Optionales Label für die linke Kennzahl (z. B. „Anzahl“). */
  @Prop({ required: false, type: String, default: 'Anzahl' })
  primaryMetricLabel!: string;

  /** Optionale zweite Kennzahl (z. B. Bewertungspunkte). */
  @Prop({ required: false, type: String, default: '' })
  secondaryValue!: string;

  @Prop({ required: false, type: String, default: '' })
  secondaryLabel!: string;

  get hasSecondaryMetric(): boolean {
    return Boolean(this.secondaryValue);
  }
}
